import type { DataSetsProps } from '@/types';
import { getOnStorage, setOnStorage } from './storageFunctions';

const IMAGE_DATASET_TYPES = new Set(['imagens', 'imagens_zip']);

export const isImageDataset = (dataset: Pick<DataSetsProps, 'TIPO_ARQUIVO'> | string): boolean => {
  const tipo = typeof dataset === 'string' ? dataset : dataset?.TIPO_ARQUIVO;
  return IMAGE_DATASET_TYPES.has(String(tipo || ''));
};

export const getKnownDatasetUrls = (datasets: DataSetsProps[] | null | undefined): Set<string> =>
  new Set((datasets || []).map((item) => item.URL_S3).filter(Boolean));

/** Descritores dos arquivos de imagem já baixados — o `datasets_imagens` do localStorage. */
export const readImageDatasets = (): DataSetsProps[] => getOnStorage('datasets_imagens') || [];

export const writeImageDatasets = (datasets: DataSetsProps[]) => {
  setOnStorage('datasets_imagens', datasets);
};

export const migrateImageDatasetsFromMain = (): DataSetsProps[] => {
  const mainDatasets = getOnStorage('datasets') || [];
  const mainWithoutImages = mainDatasets.filter((dataset) => !isImageDataset(dataset));
  const imagesFromMain = mainDatasets.filter((dataset) => isImageDataset(dataset));
  const currentImages = readImageDatasets();

  if (imagesFromMain.length) {
    const byUrl = new Map<string, DataSetsProps>();
    [...currentImages, ...imagesFromMain].forEach((dataset) => {
      if (!dataset?.URL_S3) return;
      byUrl.set(dataset.URL_S3, dataset);
    });
    writeImageDatasets(Array.from(byUrl.values()));
    setOnStorage('datasets', mainWithoutImages);
    return Array.from(byUrl.values());
  }

  return currentImages;
};

export const mergeDatasetsByUrl = (current: DataSetsProps[], incoming: DataSetsProps[]): DataSetsProps[] => {
  const byUrl = new Map<string, DataSetsProps>();
  [...current, ...incoming].forEach((dataset) => {
    if (!dataset?.URL_S3) return;
    byUrl.set(dataset.URL_S3, dataset);
  });
  return Array.from(byUrl.values());
};
